<!-- 待发区管理 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="editZone()">添加待发区</el-button>
                <div class="titile-color">系统将根据设定的待发区编号升序进行推荐</div>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">待发区名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Name" v-filter-special-char="searchData.Name" placeholder="区域名称"></el-input>
                <div class="search-name">状态</div>
                <el-select v-model="searchData.State" class="search-item" size="small" placeholder="请选择">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%"
            >
                <el-table-column prop="StoName" label="待发仓库" width="120px"></el-table-column>
                <el-table-column prop="Sort" label="待发区编号" width="200px"></el-table-column>
                <el-table-column prop="Name" label="待发区名称" width="140px"></el-table-column>
                <el-table-column label="状态" width="140px">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Remark" label="备注"></el-table-column>
                <el-table-column width="180px" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column width="130px" prop="Updatetor" label="最后更新人"></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="编辑" size="mini" type="text" @click="editZone(scope.row)"
                                >编辑</el-button
                            >
                            <el-button
                                title="删除"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delPosition(scope.row)"
                                >删除</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50, 100, 150]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!--    新增/编辑区域    -->
        <el-dialog :close-on-click-modal="false" :title="editDialogTitle" :visible.sync="editVisible" width="800px">
            <div v-loading="loading">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%;padding: 10px 30px 0 0" :rules="rules">
                    <div class="form-main">
                        <div class="form-left">
                            <el-form-item label="待发区编号" prop="Sort">
                                <!-- <el-input v-model.trim="submitData.Sort" type="number" placeholder="请输入数字"> </el-input> -->
                                <el-input
                                    v-model.trim="submitData.Sort"
                                    type="text"
                                    placeholder="请输入整数"
                                    @input="filterNumber"
                                    @keydown.native="handleKeydown"
                                    @paste="handlePaste"
                                    >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="form-right">
                            <el-form-item label="待发区名称" prop="Name">
                                <el-input style="width: 100%" v-model.trim="submitData.Name"> </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-bottom">
                        <el-form-item label="备注">
                            <el-input style="width: 100%" v-model.trim="submitData.Remark"> </el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="submitData.State" style="width: 50%" placeholder="请选择">
                                <el-option v-for="item in editStateList" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" @click="submitForm">提交</el-button>
                    <el-button @click="cancel()">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        breadcrumb,
        elTableColumn,
    },
    name: '',
    data() {
        return {
            stateList: [
                { Value: '', Text: '全部' },
                { Value: '0', Text: '正常使用' },
                { Value: '1', Text: '暂停使用' }
            ],
            warehouseName: '',
            dialogTitle: '区域信息',
            editVisible: false,
            editDialogTitle: '',
            loading:false,
            submitData: {
                WarehouseId: '',
                Id: '',
                Name: '',
                Sort: '',
                State: 0,
                Remark: "",
            },
            searchData: {
                WarehouseId: '',
                Name: '',
                State: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            allCount:0,
            permission: {},
            editStateList: [
                { Value: 0, Text: '正常使用' },
                { Value: 1, Text: '暂停使用' }
            ],
            rules: {
                Name: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Sort: [{ required: true, message: '该项必填', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.searchData.WarehouseId = this.$route.query.id;
        this.warehouseName = this.$route.query.warehouse;
        this.permission = this.$util.getPermission('warehouse');
        this.getTableData();
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常使用';
            } else if (value == 1) {
                return '暂停使用';
            }
        }
    },
    methods: {
        cancel(edit) {
            this.editVisible = false;
        },
        editZone(row) {
            this.loading = false;
            this.editDialogTitle = this.warehouseName;
            if (row) {
                this.submitData = {
                    WarehouseId: this.searchData.WarehouseId,
                    Id: row.Id,
                    Name: row.Name,
                    Sort: row.Sort,
                    State: row.State,
                    Remark: row.Remark,
                };
            }else{
                this.submitData = {
                    WarehouseId: this.searchData.WarehouseId,
                    Id: '',
                    Name: '',
                    Sort: this.allCount + 1,
                    State: 0,
                    Remark: "",
                };
            }
            this.editVisible = true;
        },
        // 提交
        submitForm() {
            let that = this;
            if(!that.submitData.Sort){
                that.$util.errorMsg("请输入编码");
                return
            }
            if(parseInt(that.submitData.Sort) > 244 ){
                that.$util.errorMsg("请输入小于244编码");
                return
            }
            if(!that.submitData.Name){
                that.$util.errorMsg("请输入名称");
                return
            }
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/UpdateOrAddToBeShippedZone',
                    data: that.submitData
                })
                .then(res => {
                    if(res.errcode == 0){
                        that.editVisible = false;
                        that.$util.successMsg(res.errmsg);
                        that.searchData.page = 1;
                        that.getTableData();
                    }else
                        that.$util.errorMsg(res.errmsg);
                    
                }).catch(() => {
                    that.loading = false;
                });
        },
        // 删除仓位
        delPosition(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该待发区域吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpShelfSpaces/DelToBeShippedZone',
                            data: {
                                WarehouseId: that.searchData.WarehouseId,
                                Id: row.Id,
                            }
                        })
                        .then(res => {
                            if(res.errcode == 0){
                                that.$util.successMsg('删除成功');
                                that.searchData.page = 1;
                                that.getTableData();
                            }else{
                                that.$util.errorMsg(res.errmsg);

                            }
                        });
                }
            });
        },
        resetSearch() {
            this.searchData = {
                WarehouseId: this.searchData.WarehouseId,
                Name: '',
                State: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetSOToBeShippedZoneList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    this.tableData = data.data;
                    this.tableDataLength = res.count;
                    this.allCount = data.allCount;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        filterNumber(e) {
            this.submitData.Sort = e.replace(/[^\d]/g, ''); // 只保留数字
        },
        // 阻止键盘输入非数字
        handleKeydown(event) {
            // 允许控制键（退格、删除、方向键等）
            const allowedKeys = [
                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 
                'ArrowUp', 'ArrowDown', 'Tab', 'Escape', 'Enter'
            ];
            // 允许Ctrl+C、Ctrl+V等组合键
            if (event.ctrlKey || event.metaKey) return;
            
            // 阻止非数字键
            if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
                event.preventDefault();
            }
        },
        // 阻止粘贴非数字内容
        handlePaste(event) {
            const clipboardData = event.clipboardData || window.clipboardData;
            const pastedText = clipboardData.getData('text');
            if (/[^\d]/.test(pastedText)) {
                event.preventDefault();
                this.$message.warning('只能输入数字');
            }
        }
    }
};
</script>
<style lang="less">
.dialog-footer{
    display: flex;
    justify-content:flex-end;
    margin-bottom: 10px;
}
.titile-color{
    color: red;
    margin-left: 20px;
}
</style>